export const thunkTypes = {
  GET_REFUND: `firstPurchase/getRefund`,
  GET_BENEFIT: `firstPurchase/getBenefit`,
  NOTIFY_BENEFIT: `firstPurchase/notifyBenefit`,
  UNNOTIFY_BENEFIT: `firstPurchase/unnotifyBenefit`,
  CONFIRM_FIRST_PURCHASE: `firstPurchase/confirmFirstPurchase`,
};
